function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMidD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mid_d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "129.25 512.71 81.42 413.36 99.81 170.49 136.61 137.38 156.47 0 0 0 0 720 212.17 720 129.25 512.71",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1196.37 394.96 1080.6 720 1279.5 720 1280 720 1280 0 1050.86 0 1196.37 394.96",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "687.34 538.47 770.75 646.4 644.82 482.04 687.34 538.47",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "770.75 646.4 777.44 720 777.44 720 770.75 646.4",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.98 648.02 315.53 720 315.53 720 231.06 482.04 289.98 648.02",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.02 203.61 216.34 64.19 263.77 141.06 303.02 203.61",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.43 394.96 527.89 203.61 495.98 294.11 460.43 394.96",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "687.34 538.47 579.4 575.26 432.22 575.26 450.19 720 777.44 720 770.75 646.4 687.34 538.47",
    style: {
      fill: "#060606"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "937.57 550.73 770.75 646.4 777.44 720 952.34 720 937.57 550.73",
    style: {
      fill: "#040404"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1059.61 720 1124.01 513.93 1050.41 482.04 1028.78 720 1059.61 720",
    style: {
      fill: "#090909"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1059.61 720 1080.6 720 1196.37 394.96 1124.01 513.93 1059.61 720",
    style: {
      fill: "#101010"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "952.34 720 1028.78 720 1050.41 482.04 937.57 550.73 952.34 720",
    style: {
      fill: "#080808"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.06 482.04 315.53 720 450.19 720 432.22 575.26 231.06 482.04",
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.53 720 289.98 648.02 261.15 720 315.53 720",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.18 507.39 253.97 720 261.15 720 289.98 648.02 231.06 482.04 182 464.87 172.18 507.39",
    style: {
      fill: "#0b0b0b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.18 507.39 129.66 482.04 81.42 413.36 129.25 512.71 212.17 720 253.47 720 172.18 507.39",
    style: {
      fill: "#0f0f0f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.18 507.39 253.47 720 253.97 720 172.18 507.39",
    style: {
      fill: "#0f0f0f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "603.94 464.87 474.74 464.87 432.22 575.26 579.4 575.26 687.34 538.47 644.82 482.04 603.94 464.87",
    style: {
      fill: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "832.9 64.19 857.43 394.96 937.57 550.73 1050.41 482.04 942.6 0 865.5 0 832.9 64.19",
    style: {
      fill: "#262626"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1050.41 482.04 1124.01 513.93 1196.37 394.96 1050.86 0 942.6 0 1050.41 482.04",
    style: {
      fill: "#252525"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.82 482.04 610.07 429.3 603.94 464.87 644.82 482.04",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "797.74 350.87 857.43 394.96 832.9 64.19 793.91 0 692.34 0 666.49 88.31 797.74 350.87",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.74 464.87 603.94 464.87 610.07 429.3 527.89 203.61 483.73 375.33 474.74 464.87",
    style: {
      fill: "#151515"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "536.48 158.23 797.74 350.87 666.49 88.31 536.48 158.23",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "857.43 394.96 797.74 350.87 536.48 158.23 527.89 203.61 610.07 429.3 644.82 482.04 770.75 646.4 937.57 550.73 857.43 394.96",
    style: {
      fill: "#181818"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.32 141.06 527.89 203.61 536.48 158.23 513.17 112.84 492.32 141.06",
    style: {
      fill: "#1b1b1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.82 388.82 231.06 482.04 432.22 575.26 474.74 464.87 321.82 388.82",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 354.54 321.82 388.82 474.74 464.87 460.43 394.96 362.3 354.54",
    style: {
      fill: "#121212"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "865.5 0 829.07 0 832.9 64.19 865.5 0",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "536.48 14.72 513.17 112.84 536.48 158.23 580.32 0 543.98 0 536.48 14.72",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.74 464.87 483.73 375.33 527.89 203.61 460.43 394.96 474.74 464.87",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.05 158.23 495.98 294.11 527.89 203.61 492.32 141.06 480.05 158.23",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "495.98 294.11 480.05 158.23 384.38 256.35 362.3 354.54 460.43 394.96 495.98 294.11",
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182 464.87 231.06 482.04 202.85 421.94 182 464.87",
    style: {
      fill: "#0d0d0d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "666.49 88.31 692.34 0 580.32 0 536.48 158.23 666.49 88.31",
    style: {
      fill: "#2c2c2c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "829.07 0 793.91 0 832.9 64.19 829.07 0",
    style: {
      fill: "#2c2c2c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.18 507.39 182 464.87 182 366.75 152.56 247.36 103.49 284.97 81.42 413.36 129.66 482.04 172.18 507.39",
    style: {
      fill: "#131313"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.3 354.54 384.38 256.35 303.02 203.61 263.77 141.06 182 366.75 182 464.87 202.85 421.94 231.06 482.04 321.82 388.82 362.3 354.54",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.34 64.19 121.48 219.59 103.49 284.97 152.56 247.36 182 366.75 263.77 141.06 216.34 64.19",
    style: {
      fill: "#1e1e1e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.48 219.59 216.34 64.19 136.61 137.38 99.81 170.49 81.42 413.36 103.49 284.97 121.48 219.59",
    style: {
      fill: "#1d1d1d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.51 0 156.47 0 136.61 137.38 216.34 64.19 206.51 0",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.51 0 216.34 64.19 244.31 0 206.51 0",
    style: {
      fill: "#2e2e2e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.32 141.06 513.17 112.84 536.48 14.72 538.15 0 347.27 0 303.02 203.61 384.38 256.35 480.05 158.23 492.32 141.06",
    style: {
      fill: "#272727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "539.4 0 538.15 0 536.48 14.72 539.4 0",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.38 0 283.24 0 216.34 64.19 303.02 203.61 330.38 0",
    style: {
      fill: "#1f1f1f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "543.98 0 539.4 0 536.48 14.72 543.98 0",
    style: {
      fill: "#292929"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.38 0 303.02 203.61 347.27 0 330.38 0",
    style: {
      fill: "#232323"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.31 0 216.34 64.19 283.24 0 244.31 0",
    style: {
      fill: "#313131"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidD);
export default __webpack_public_path__ + "static/media/mid_d.91600af2fac58d4ffd676061f6119355.svg";
export { ForwardRef as ReactComponent };